import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const errorCircleFilledVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ErrorCircleFilledProps = {
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  fill?: string;
} & React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof errorCircleFilledVariants>;

const ErrorCircleFilled = React.forwardRef<
  SVGSVGElement,
  ErrorCircleFilledProps
>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          errorCircleFilledVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox ?? '0 0 24 24'}
        width={width}
        {...props}
      >
        <path d="M12 2.40002C14.5461 2.40002 16.9879 3.41145 18.7882 5.2118C20.5886 7.01215 21.6 9.45395 21.6 12C21.6 14.5461 20.5886 16.9879 18.7882 18.7883C16.9879 20.5886 14.5461 21.6 12 21.6C9.45392 21.6 7.01212 20.5886 5.21178 18.7883C3.41143 16.9879 2.4 14.5461 2.4 12C2.4 9.45395 3.41143 7.01215 5.21178 5.2118C7.01212 3.41145 9.45392 2.40002 12 2.40002ZM12 15C11.7613 15 11.5324 15.0948 11.3636 15.2636C11.1948 15.4324 11.1 15.6613 11.1 15.9C11.1 16.1387 11.1948 16.3676 11.3636 16.5364C11.5324 16.7052 11.7613 16.8 12 16.8C12.2387 16.8 12.4676 16.7052 12.6364 16.5364C12.8052 16.3676 12.9 16.1387 12.9 15.9C12.9 15.6613 12.8052 15.4324 12.6364 15.2636C12.4676 15.0948 12.2387 15 12 15ZM12 7.20002C11.8596 7.19998 11.7236 7.24919 11.6157 7.33909C11.5078 7.42899 11.4349 7.55389 11.4096 7.69202L11.4 7.80002V13.2L11.4096 13.308C11.4346 13.4464 11.5075 13.5715 11.6154 13.6616C11.7233 13.7518 11.8594 13.8011 12 13.8011C12.1406 13.8011 12.2767 13.7518 12.3846 13.6616C12.4925 13.5715 12.5654 13.4464 12.5904 13.308L12.6 13.2V7.80002L12.5904 7.69202C12.5651 7.55389 12.4922 7.42899 12.3843 7.33909C12.2764 7.24919 12.1404 7.19998 12 7.20002Z" />
      </svg>
    );
  },
);

ErrorCircleFilled.displayName = 'ErrorCircleFilled';

export { ErrorCircleFilled, errorCircleFilledVariants };
